import { render, staticRenderFns } from "./GameMasterComponent.vue?vue&type=template&id=48369961&scoped=true"
import script from "./GameMasterComponent.vue?vue&type=script&lang=js"
export * from "./GameMasterComponent.vue?vue&type=script&lang=js"
import style0 from "./GameMasterComponent.vue?vue&type=style&index=0&id=48369961&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48369961",
  null
  
)

export default component.exports